/** Mapa id → ítem activo del menú público. */
import { buildCartLine, isPizzaItem, sizePrice } from './pizzaPricing';

export function buildMenuItemMap(categories) {
  const map = new Map();
  for (const cat of categories || []) {
    for (const item of cat.items || []) {
      if (item?.id) map.set(item.id, item);
    }
  }
  return map;
}

/**
 * Alinea el carrito con el menú actual (precios e ids válidos).
 */
export function reconcileCart(cart, categories, toppingExtras = []) {
  const map = buildMenuItemMap(categories);
  for (const t of toppingExtras || []) {
    if (t?.id) map.set(t.id, t);
  }
  const valid = [];
  const removed = [];
  for (const line of cart || []) {
    const item = map.get(line.menu_item_id);
    if (!item) {
      removed.push(line.name || 'Producto');
      continue;
    }
    const half = line.half_specialty_id ? map.get(line.half_specialty_id) : null;
    const extras = (line.extra_topping_ids || line.extra_toppings || [])
      .map((t) => map.get(typeof t === 'string' ? t : t.id))
      .filter(Boolean);
    const rebuilt = buildCartLine({
      item,
      sizeKey: line.size_key || 'mediana',
      qty: Math.max(1, Number(line.qty) || 1),
      halfSpecialty: half,
      extraToppings: extras,
      notes: line.notes || '',
    });
    valid.push(rebuilt);
  }
  return { cart: valid, removed };
}

export function formatLineLabel(line) {
  const parts = [line.name];
  if (line.size_label) parts.push(line.size_label);
  if (line.half_specialty_name) parts.push(`Mitad: ${line.half_specialty_name}`);
  const extras = (line.extra_toppings || []).map((t) => t.name).filter(Boolean);
  if (extras.length) parts.push(`Extra: ${extras.join(', ')}`);
  return parts.join(' · ');
}

export { isPizzaItem, sizePrice };
